<template>
  <div>
    <!-- edit inside events modal -->
    <modal
      name="edit-inside-event-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-event
        title="odmor/doručak"
        :selectedDailyLog="selectedDailyLog"
        eventsType="inside"
        :employeeName="selectedNameValue"
    /></modal>

    <!-- edit outside events modal -->
    <modal
      name="edit-outside-event-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-event
        title="Izlasci"
        :selectedDailyLog="selectedDailyLog"
        eventsType="outside"
        :employeeName="selectedNameValue"
    /></modal>

    <!-- print area -->
    <div class="ev-table-section">
      <!-- Table Header -->
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-table-icon">🏢</span>
          {{ department.name }}
          <span class="ev-badge-light">{{
            startDate.toLocaleDateString("sr-latn-cs")
          }}</span>
        </h3>
        <span class="ev-table-count">{{ employeeCount }}</span>
      </div>

      <!-- Table -->
      <div class="ev-table-container">
        <vue-table-dynamic
          :params="params"
          @cell-click="tableCellClicked"
          @on-row-dblclick="onRowDoubleClick"
          @row-click="onRowClicked"
          @cell-contextmenu="cm"
          ><template v-slot:column-1="{ props }">
            <span
              :style="{
                background: props.cellData.background,
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            > </template
          ><template v-slot:column-4="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            > </template
          ><template v-slot:column-5="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            > </template
          ><template v-slot:column-6="{ props }">
            <span
              :style="{
                background: props.cellData.background,
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-7="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-8="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-9="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-10="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-11="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
        </vue-table-dynamic>
      </div>

      <!--Export vidget -->
      <export-vidget v-show="false" />

      <!-- contex menu -->
      <context-menu :display="showContextMenu" ref="menu">
        <ul class="ev-context-menu-list">
          <li
            @click="cmCommentClicked"
            v-show="isCommentCMVisible"
            class="ev-context-menu-item"
          >
            <span class="ev-context-icon">✏️</span>
            Komentar
          </li>
          <li
            @click="cmLateClicked"
            v-show="isLateCMVisible"
            class="ev-context-menu-item ev-context-menu-item--warning"
          >
            <span class="ev-context-icon">⏰</span>
            Status kašnjenja
          </li>
          <li
            @click="cmViewDetails"
            v-show="isCommentCMVisible"
            class="ev-context-menu-item ev-context-menu-item--success"
          >
            <span class="ev-context-icon">🔍</span>
            Vidi detalje...
          </li>
        </ul>
      </context-menu>

      <!-- spinner -->
      <div class="ev-loading-inline" v-show="isLoading">
        <div class="ev-loading-spinner-sm"></div>
        <span>Učitavanje...</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueTableDynamic from "vue-table-dynamic";
// import ReportService from "../../services/report.service";
import ExportVidget from "../parts/ExportVidget.vue";
import ContextMenu from "../parts/ContextMenu.vue";
import ReportService from "../../services/report.service";
import {
  // getDepartmentFromEmployeeId,
  getDateFromTicks,
  getSecondsFromTicks,
  maskIfEquealsValue,
  // getStartedYesterdayStayString,
  // getStayedTillTomorrowString,
  getDailyLogsFromDepartmentId,
  getBusinessEventString,
  getRestEventString,
  getPrivateEventString,
  getPauseEventString,
  getPauseEventLength,
  getStatusCodeFromStatusId,
  addDays,
  // getStatusCodeFromStatusId,
} from "../../_helpers/arrangers";
const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
  "#ecfeff",
  "#fc3d03",
  "#faa614",
  "#f08bb7",
  "#ea3636",
];
const MEDIUM_LATE = 600;
const EXTREME_LATE = 1800;
export default {
  name: "DailyPresenceTable",
  components: {
    VueTableDynamic,
    ExportVidget,
    ContextMenu,
  },
  props: {
    department: Object,
    startDate: Date,
    endDate: Date,
    statuses: Array,
    departmentData: Array,
    inputDailyLogs: Array,
    filterLateValue: Number,
  },
  data() {
    return {
      selectedDailyLog: null,
      selectedName: null,
      selectedEmplyoee: null,
      selectedNameValue: null,
      dailyLogs: [],
      employees: [],
      isLoading: false,
      showContextMenu: false,
      employeeId: null,
      departmentId: null,
      isCommentCMVisible: true,
      isLateCMVisible: false,
      dotOrArrow: true,
      params: {
        data: [
          [
            "Index",
            "Ime i prezime",
            "Dolazak",
            "Odlazak",
            "Kašnjenje",
            "KO/KN",
            "Status",
            "Službeno",
            "Odlazak sa posla",
            "Privatno",
            "Pauza",
            "Ukupno",
            // "status",
            "Komentar",
          ],
        ],
        header: "row",
        enableSearch: false,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "4%" },
          { column: 1, width: "20%" },
          { column: 2, width: 85 },
          { column: 3, width: 85 },
          { column: 4, width: 70 },
          { column: 5, width: 45 },
          { column: 6, width: 50 },
          { column: 11, width: 75 },
          { column: 12, width: "20%" },
        ],
        sort: [0, 1],
        highlight: { column: [-2] },
        highlightedColor: colors[6],
        wordWrap: "break-word",
        whiteSpace: "normal",
      },
    };
  },
  computed: {
    employeeCount() {
      // Count only rows in the table (excluding header row)
      return this.params.data.length > 1 ? this.params.data.length - 1 : 0;
    },
  },
  mounted() {
    // this.arrangeData(undefined, this.department.id);
    // this.arrangeDataSimple(this.department.id);
    this.arrangeData();
  },
  methods: {
    openContextMenu(e) {
      this.$refs.menu.open(e);
    },
    cmEditClicked() {
      this.$refs.menu.close();
    },
    cmCommentClicked() {
      this.recalcEmployee().then((rs) => {
        console.log(rs);
      });
      this.$emit("editCommentClicked", {
        emp: this.selectedEmplyoee,
        dl: this.selectedDailyLog,
      });
      this.$refs.menu.close();
    },
    cmViewDetails() {
      console.log(this.selectedEmplyoee.firstName);
      const theDate = new Date(
        this.startDate.getTime() - this.startDate.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      this.$router.push(
        "/user/ManualFix?date=" +
          theDate +
          "&employeeId=" +
          this.selectedEmplyoee.employeeId
      );

      // // napravi url za rutu (u zavisnosti da li je hash mode ili history mode)
      // const routeData = this.$router.resolve({
      //   path: "/user/ManualFix",
      //   query: {
      //     date: theDate,
      //     employeeId: this.selectedEmplyoee.employeeId,
      //   },
      // });

      // // otvori u novom tabu
      // window.open(routeData.href, "_blank", "noopener,noreferrer");

      // opciono: zatvori context menu
      this.$refs.menu.close();
    },
    cmLateClicked() {
      console.log(this.selectedDailyLog.isLate);
      console.log(this.departmentId);
      // this.employees.push({
      //   name: "jedan", // emp.firstName + " " + emp.lastName,
      //   id: 1, //emp.employeeId,
      // });
      // ReportService.GetNormalizedAccessDataByTimeRange(
      //   this.startDate,
      //   this.endDate,
      //   this.selectedEmplyoee.employeeId,
      //   this.departmentId
      // ).then(() => {
      console.log("XXX2");
      console.log(this.selectedEmplyoee);
      console.log(this.selectedDailyLog);
      this.$emit("editLateJustifiedClicked", {
        emp: this.selectedEmplyoee,
        dl: this.selectedDailyLog,
      });
      // });
    },
    resetUi() {},
    tableCellClicked(row, column, data) {
      console.log(row);
      console.log(column);
      console.log("selectedDailyLog: ", this.selectedDailyLog);
      if (column == 1) {
        // selected employee
        this.selectedEmplyoee = this.employees.find(
          (x) => x.correspondingRowId === row
        );
        console.log("selected employee:");
        console.log(this.selectedEmplyoee.firstName);
        //
        this.recalcEmployee().then((employee) => {
          console.log(employee.data[0]);
          this.selectedDailyLog = employee.data[0];
          this.$emit("showEditDailyLogClicked", {
            emp: this.selectedEmplyoee,
            dl: this.selectedDailyLog,
          });
        });
      } else if (column == 11) {
        alert(data);
      }
    },
    recalcEmployee() {
      // console.log("xxx");
      // console.log(this.departmentId);
      // this.employees.push({
      //   name: "jedan", // emp.firstName + " " + emp.lastName,
      //   id: 1, //emp.employeeId,
      // });
      return ReportService.GetNormalizedAccessDataByTimeRange(
        this.startDate,
        this.endDate,
        this.selectedEmplyoee.employeeId,
        this.departmentId
      );
    },
    onRowDoubleClick(params) {
      console.log(params);
    },
    onRowClicked() {},
    cm(params, row, column) {
      console.log("context");
      console.log(this.params.data);
      console.log(this.employees);
      console.log(row);
      console.log(column);
      this.selectedEmplyoee = this.employees.find(
        (x) => x.correspondingRowId === row
      );
      console.log("papaja");
      this.selectedDailyLog = this.dailyLogs.find(
        (x) => x.employeeId === this.selectedEmplyoee.employeeId
      );
      console.log(this.dailyLogs);
      console.log(this.selectedDailyLog);
      switch (column) {
        case 5:
          if (this.selectedDailyLog.isLate) {
            this.isCommentCMVisible = false;
            this.isLateCMVisible = true;
          } else {
            this.isCommentCMVisible = true;
            this.isLateCMVisible = false;
          }
          break;
        default:
          this.isCommentCMVisible = true;
          this.isLateCMVisible = false;
      }
      console.log(this.selectedEmplyoee.firstName);
      this.openContextMenu(params);
    },
    recalculateLog(element, ndx) {
      if (element.didIstartedYesterday && element.didIstayedTillTomorrow) {
        // rec
        ReportService.GetEarliestPedestrianEntryByEmployeeIdAndDate(
          this.startDate,
          element.employeeId
        ).then((response) => {
          // arrival time override
          this.dotOrArrow = true;
          element.arrivalTimeGeneral = response.data.accessTime;
          console.log(response.data.accessTime);
          if (response.data.accessTime === undefined) {
            console.log("BINGO BONGO");
          }
          ReportService.GetEarliestPedestrianExitByEmployeeIdAndDate(
            addDays(this.startDate, 1),
            element.employeeId
          ).then((response) => {
            // departure time override
            element.departureTimeGeneral = response.data.accessTime;
            this.addElement(element, ndx);
          });
        });
      } else if (element.didIstartedYesterday) {
        // rec
        ReportService.GetEarliestPedestrianEntryByEmployeeIdAndDate(
          this.startDate,
          element.employeeId
        ).then((response) => {
          // arrival time override
          this.dotOrArrow = true;
          console.log(response.data.accessTime);
          if (response.data.accessTime === undefined) {
            ReportService.GetLatestPedestrianEntryByEmployeeIdAndDate(
              addDays(this.startDate, -1),
              element.employeeId
            ).then((response) => {
              //arrival time double override
              this.dotOrArrow = false;
              element.arrivalTimeGeneral = response.data.accessTime;
              this.addElement(element, ndx);
            });
          } else {
            element.arrivalTimeGeneral = response.data.accessTime;
            this.addElement(element, ndx);
          }
        });
      } else if (element.didIstayedTillTomorrow) {
        ReportService.GetEarliestPedestrianExitByEmployeeIdAndDate(
          addDays(this.startDate, 1),
          element.employeeId
        ).then((response) => {
          // departure time override
          element.departureTimeGeneral = response.data.accessTime;
          this.addElement(element, ndx);
        });
      } else {
        this.addElement(element, ndx);
      }
    },
    findFormerRow(ndx) {
      // napraviti od ovoga rekurzivnu funkciju
      let myRow = this.params.data.find((x) => x[0] === ndx - 1);
      if (myRow === undefined) {
        myRow = this.params.data.find((x) => x[0] === ndx - 2);
        if (myRow === undefined) {
          myRow = this.params.data.find((x) => x[0] === ndx - 3);
          if (myRow === undefined) {
            myRow = this.params.data.find((x) => x[0] === ndx - 4);
            if (myRow === undefined) {
              myRow = this.params.data.find((x) => x[0] === ndx - 5);
              if (myRow === undefined) {
                myRow = this.params.data.find((x) => x[0] === ndx - 6);
                if (myRow === undefined) {
                  myRow = this.params.data.find((x) => x[0] === ndx - 7);
                  if (myRow === undefined) {
                    myRow = this.params.data.find((x) => x[0] === ndx - 8);
                    if (myRow === undefined) {
                      myRow = this.params.data.find((x) => x[0] === ndx - 9);
                      if (myRow === undefined) {
                        myRow = this.params.data.find((x) => x[0] === ndx - 10);
                        if (myRow === undefined) {
                          myRow = this.params.data.find(
                            (x) => x[0] === ndx - 11
                          );
                          if (myRow === undefined) {
                            myRow = this.params.data.find(
                              (x) => x[0] === ndx - 12
                            );
                            if (myRow === undefined) {
                              myRow = this.params.data.find(
                                (x) => x[0] === ndx - 13
                              );
                              if (myRow === undefined) {
                                myRow = this.params.data.find(
                                  (x) => x[0] === ndx - 14
                                );
                                if (myRow === undefined) {
                                  myRow = this.params.data.find(
                                    (x) => x[0] === ndx - 15
                                  );
                                  if (myRow === undefined) {
                                    myRow = this.params.data.find(
                                      (x) => x[0] === ndx - 16
                                    );
                                    if (myRow === undefined) {
                                      myRow = this.params.data.find(
                                        (x) => x[0] === ndx - 17
                                      );
                                      if (myRow === undefined) {
                                        myRow = this.params.data.find(
                                          (x) => x[0] === ndx - 18
                                        );
                                        if (myRow === undefined) {
                                          myRow = this.params.data.find(
                                            (x) => x[0] === ndx - 19
                                          );
                                          if (myRow === undefined) {
                                            myRow = this.params.data.find(
                                              (x) => x[0] === ndx - 20
                                            );
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return myRow;
    },
    addElement(element, ndx) {
      this.dailyLogs.push(element);
      let selectedEmp = this.employees.find(
        (x) => x.employeeId === element.employeeId
      );
      let index = this.employees.indexOf(selectedEmp);
      // console.log("CIKA PAJO: ", ndx);
      // console.log("CIKA PAJO: ", index);
      // console.log("CIKA PAJO: ", element);
      // console.log("ČIKA PAJO; ", element.employeeId);
      // console.log("ČIKA PAJO); ", this.employees);
      this.employees[index].correspondingRowId = ndx;
      // filters
      let lateFiltering = false;
      if (parseInt(this.filterLateValue) > 0) {
        lateFiltering = true;
      }
      if (lateFiltering) {
        if (
          getSecondsFromTicks(element.lateWorkhours) <
          this.filterLateValue * 60
        ) {
          element.filterOut = true;
        }
      }
      if (!element.filterOut) {
        // let myEmployee = this.employees.find(
        //   (x) => x.employeeId === element.employeeId
        // );
        // if (myEmployee.firstName === "Dragutin") {
        //   console.log("debug!");
        //   console.log("svi rowovi");
        //   let myRows = [];
        //   this.params.data.forEach((element) => {
        //     myRows.push(element);
        //   });
        //   console.log(myRows);
        //   let myRow = this.findFormerRow(ndx);
        //   console.log("prethodni row");
        //   console.log(myRow);
        // }
        // nađimo index elementa čiji je index ndx - 1 (za 16, 15)
        let prethodnik = ndx - 1;
        // let myRow = this.params.data.find((x) => x[0] === ndx - 1);
        let myRow = this.findFormerRow(ndx);
        if (prethodnik === 0) myRow = this.params.data[0];
        let index = this.params.data.indexOf(myRow);
        if (myRow === undefined) {
          index = this.params.data.length - 1;
        }
        this.params.data.splice(index + 1, 0, [
          ndx,
          // Ime i prezime
          {
            value:
              this.employees.find((x) => x.employeeId === element.employeeId)
                .firstName +
              " " +
              this.employees.find((x) => x.employeeId === element.employeeId)
                .lastName,
            id: `${1}`,
            background: element.statusId == 7 ? colors[9] : "transparent",
            color: element.arrivalTimeGeneral
              ? element.totalWorkhoursThisDay >= 288000000000 // Less than 8 hours - red
                ? colors[1]
                : colors[2]
              : colors[0],
            decoration: element.arrivalTimeGeneral ? "underline" : "none",
            cursor: element.arrivalTimeGeneral ? "zoom-in" : "default",
          },
          // this.employees.find((x) => x.employeeId === element.employeeId)
          //   .firstName +
          //   " " +
          //   this.employees.find((x) => x.employeeId === element.employeeId)
          //     .lastName,
          // Dolazak
          this.calculateStartedYesterdayTime(element),
          // Odlazak
          this.calculateStayesTillTomorrowTime(element),
          // Kašnjenje
          {
            value: maskIfEquealsValue(
              getDateFromTicks(element.lateWorkhours),
              "00:00:00"
            ),
            id: `${1}`,
            color:
              getSecondsFromTicks(element.lateWorkhours) > EXTREME_LATE
                ? colors[7]
                : getSecondsFromTicks(element.lateWorkhours) > MEDIUM_LATE
                ? colors[8]
                : colors[5],
            decoration: "none",
            cursor: "default",
          },
          // KO/KN
          {
            value: maskIfEquealsValue(
              element.isLate === null
                ? ""
                : element.isLateJustified === true
                ? "KO"
                : "KN"
            ),
            id: `${1}`,
            color:
              getSecondsFromTicks(element.lateWorkhours) > EXTREME_LATE
                ? colors[7]
                : getSecondsFromTicks(element.lateWorkhours) > MEDIUM_LATE
                ? colors[8]
                : colors[5],
            decoration: "none",
            cursor: "default",
          },
          // STATUS
          {
            value: maskIfEquealsValue(
              getStatusCodeFromStatusId(
                element.statusId,
                element.statusIdOverride,
                this.$store.state.general.statuses
              ),
              "0"
            ),
            id: `${1}`,
            background: element.statusId == 7 ? colors[9] : "transparent",
            color:
              getSecondsFromTicks(element.lateWorkhours) > EXTREME_LATE
                ? colors[7]
                : getSecondsFromTicks(element.lateWorkhours) > MEDIUM_LATE
                ? colors[8]
                : colors[5],
            decoration: "none",
            cursor: "default",
          },
          // Izlasci
          {
            value: maskIfEquealsValue(
              getBusinessEventString(element.outsideEvent),
              "br:0 vr:00:00:00"
            ),
            id: `${1}`,
            color: element.outsideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.outsideEvent.length > 0 ? "underline" : "none",
            cursor: element.outsideEvent.length > 0 ? "zoom-in" : "default",
          },
          // Odlazak sa polsa
          {
            value: maskIfEquealsValue(
              getRestEventString(element.outsideEvent),
              "br:0 vr:00:00:00"
            ),
            id: `${1}`,
            color: element.outsideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.outsideEvent.length > 0 ? "underline" : "none",
            cursor: element.outsideEvent.length > 0 ? "zoom-in" : "default",
          },
          // Privatno ili pauza TODO: ovo je privatno
          {
            value: maskIfEquealsValue(
              getPrivateEventString(element.outsideEvent),
              "br:0 vr:00:00:00"
            ),
            id: `${1}`,
            color: element.outsideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.outsideEvent.length > 0 ? "underline" : "none",
            cursor: element.outsideEvent.length > 0 ? "zoom-in" : "default",
          },
          // pauza
          {
            value: maskIfEquealsValue(
              getPauseEventString(element.insideEvent),
              "br:0 vr:00:00:00"
            ),
            id: `${1}`,
            color:
              getPauseEventLength(element.insideEvent) > 18000000000
                ? colors[10]
                : colors[5], // Sve preko pola sata druga boja
            decoration: element.insideEvent.length > 0 ? "underline" : "none",
            cursor: element.insideEvent.length > 0 ? "zoom-in" : "default",
          },
          // maskIfEquealsValue(
          //   getDateFromTicks(element.workhoursOutsideBuildingThisDay),
          //   "00:00:00"
          // ),
          {
            value: maskIfEquealsValue(
              getDateFromTicks(element.totalWorkhoursThisDay),
              "00:00:00"
            ),
            id: `${1}`,
            color:
              element.totalWorkhoursThisDay >= 288000000000 // Less than 8 hours - red
                ? colors[0]
                : colors[2],
            decoration: "none",
            cursor: "default",
          },
          // getStatusCodeFromStatusId(element.statusId, this.statuses),
          maskIfEquealsValue(
            maskIfEquealsValue(element.note, "null"),
            "undefined"
          ),
        ]);
      }
    },
    calculateStartedYesterdayTime(element) {
      if (element.didIstartedYesterday) {
        return (
          maskIfEquealsValue(
            new Date(element.arrivalTimeGeneral).toLocaleTimeString(
              "sr-latn-cs"
            ),
            "01:00:00"
          ) + (this.dotOrArrow ? "." : "⬅️")
        );
      } else {
        return maskIfEquealsValue(
          new Date(element.arrivalTimeGeneral).toLocaleTimeString("sr-latn-cs"),
          "01:00:00"
        );
      }
    },
    calculateStayesTillTomorrowTime(element) {
      if (element.didIstayedTillTomorrow) {
        return (
          "➡️" +
          maskIfEquealsValue(
            new Date(element.departureTimeGeneral).toLocaleTimeString(
              "sr-latn-cs"
            ),
            "01:00:00"
          )
        );
      } else {
        return maskIfEquealsValue(
          new Date(element.departureTimeGeneral).toLocaleTimeString(
            "sr-latn-cs"
          ),
          "01:00:00"
        );
      }
    },
    arrangeData() {
      // reset ui
      this.resetUi(false);
      // find logs belonging to my department
      let myDailyLogs = getDailyLogsFromDepartmentId(
        this.inputDailyLogs,
        this.department.id
      );
      let ndx = 1;
      // extract my department from department data
      let myDepartment = this.departmentData.find((d) => {
        return d.departmentId === this.department.id;
      });
      // console.log("ČIKA PAKA: ", myDepartment);
      // console.log("ČIKA PAKA: ", myDailyLogs);
      this.employees = myDepartment.employee;
      // populate table
      myDailyLogs.forEach((element) => {
        this.recalculateLog(element, ndx++);
      });
    },
  },
};
</script>

<style scoped>
/* Context Menu Warning */
.ev-context-menu-item--warning {
  color: #d97706;
}

.ev-context-menu-item--warning:hover {
  background-color: #fef3c7;
}

/* Loading Inline */
.ev-loading-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  color: var(--ev-text-muted);
  font-size: 14px;
}

.ev-loading-spinner-sm {
  width: 20px;
  height: 20px;
  border: 2px solid var(--ev-border);
  border-top-color: var(--ev-primary-start);
  border-radius: 50%;
  animation: ev-spin 1s linear infinite;
}

@keyframes ev-spin {
  to {
    transform: rotate(360deg);
  }
}

@media print {
  .ev-table-section,
  .ev-table-container {
    width: 100% !important;
    max-width: 100% !important;
    overflow: visible !important;
  }

  .ev-table-header {
    padding: 6px 10px !important;
  }

  :deep(.v-table-dynamic) {
    width: 100% !important;
    max-width: 100% !important;
    overflow: visible !important;
  }

  :deep(.v-table) {
    width: 100% !important;
    table-layout: fixed !important;
  }

  :deep(.v-table th),
  :deep(.v-table td) {
    font-size: 10px !important;
    padding: 2px 4px !important;
    white-space: normal !important;
    word-break: break-word !important;
  }
}

@media print and (orientation: portrait) {
  .ev-table-section {
    zoom: 0.82;
    transform-origin: top left;
  }

  .ev-table-container {
    padding: 0 !important;
  }

  :deep(.v-table th),
  :deep(.v-table td) {
    font-size: 9px !important;
    padding: 1px 2px !important;
  }
}
</style>